import CompassNameIcon from "../images/general/CgiNameIconBlack.svg";
import CompassLogoGradient from "../images/general/CompassIconGradient.svg";
import CgiCompassSquare from "../images/home/CgiCompassSquare.png";
import CompassTablet from "../images/home/CompassTablet.png";
import ContactTorsten from "../images/home/contact/TorstenT.jpg";
import ContactPatrick from "../images/home/contact/Patrick.jpg";
import ContactJulian from "../images/home/contact/Julian.jpg";
import AIIcon from "../images/home/gradientSquares/AIIcon.svg";
import BenchmarkingIcon from "../images/home/gradientSquares/BenchmarkingIcon.svg";
import BusinessIcon from "../images/home/gradientSquares/BusinessIcon.svg";
import CloudIcon from "../images/home/gradientSquares/CloudIcon.svg";
import CustomizationIcon from "../images/home/gradientSquares/CustomizationIcon.svg";
import TimesaverIcon from "../images/home/gradientSquares/TimesaverIcon.svg";
import HexagonDots from "../images/home/hexagons/HexagonDots.svg";
import HexagonsLeft from "../images/home/hexagons/HexagonalsLeft.png";
import HexagonsRight from "../images/home/hexagons/HexagonalsRight.png";
import CompassTeaser from "../videos/CGICompassTeaser.mp4";
import SpecialText from "../components/SpecialText";
import AboutCGI from "../components/AboutCGI";
import ContactBoxGradient from "../components/ContactBoxGradient";
import InfoBoxGradient from "../components/InfoBoxGradient";
import CategoryHexagon from "../components/CategoryHexagon";
import FeatureBlock from "../components/FeatureBlock";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  CGI_GRADIENT_A,
  CGI_GRADIENT_A_45DEG,
  CGI_GRADIENT_B_45DEG,
  CGI_GREY,
  CGI_RED,
} from "../helpers/enums";
import { Box, Button, Container, Icon, Typography } from "@mui/material";

export default function Home() {
  const { user } = useAuthenticator();
  const isAuthenticated = !!user;

  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <>
      {!isAuthenticated && (
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="outlined"
            sx={{ mt: 3, mr: 5 }}
            onClick={() => navigate("/login")}
          >
            Login
          </Button>
        </Box>
      )}
      <Container
        maxWidth="lg"
        sx={{ mt: 5, width: 1, px: "0 !important", position: "relative" }}
      >
        <Box
          component="img"
          draggable={false}
          src={HexagonsLeft}
          sx={{
            display: { xs: "none", lg: "block" },
            maxWidth: 300,
            width: "auto",
            height: "auto",
            objectFit: "contain",
            position: "absolute",
            top: 340,
            left: 0,
            zIndex: 100,
            userSelect: "none",
          }}
        />
        <Box
          component="img"
          draggable={false}
          src={HexagonsRight}
          sx={{
            display: { xs: "none", lg: "block" },
            maxWidth: 300,
            width: "auto",
            height: "auto",
            objectFit: "contain",
            position: "absolute",
            top: 350,
            right: 0,
            zIndex: 100,
            userSelect: "none",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              mt: 4,
            }}
          >
            <Icon sx={{ width: "auto", height: "auto" }}>
              <img
                draggable={false}
                src={CompassLogoGradient}
                height={"55px"}
              />
            </Icon>
            <Icon sx={{ width: "auto", height: "auto", ml: 2 }}>
              <img draggable={false} src={CompassNameIcon} height="50px" />
            </Icon>
          </Box>
          <Typography
            align="center"
            sx={{
              width: { xs: 4 / 5, md: 3 / 5 },
              fontSize: { xs: 35, md: 70 },
              lineHeight: "100%",
              mt: 9,
              fontWeight: 500,
              // filter: "drop-shadow(0px 3px 1px #777)",
            }}
          >
            <SpecialText
              style={{
                background: CGI_GRADIENT_A_45DEG,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("createEarly")}
            </SpecialText>
            {` ${t("forAnyTopic")}`}
          </Typography>{" "}
          <Box
            sx={{
              height: { xs: 200, sm: 225, md: 375 },
              width: { xs: "auto", md: 660 },
              maxWidth: 0.95,
              // backgroundImage: `url(${image})`,
              mt: 2,
              border: 1,
              borderRadius: 8,
              borderColor: CGI_RED,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              overflow: "hidden",
              justifyContent: "center",
              display: "flex",
              userSelect: "none",
              zIndex: 1000,
            }}
          >
            <video className="videoTag" autoPlay loop muted playsInline>
              <source src={CompassTeaser} type="video/mp4" />
            </video>
          </Box>
          {/* <Box
            component="img"
            src={CompassAssessmentList}
            sx={{
              maxWidth: 0.62,
              width: "auto",
              height: "auto",
              objectFit: "contain",
              userSelect: "none",
            }}
          /> */}
          <Typography
            align="center"
            sx={{
              width: { xs: 0.8, md: 0.5 },
              fontSize: { xs: 13.5, md: 18 },
              mt: 7,
              fontFamily: "Inter",
            }}
          >
            {`${t("compassAI")} `}
            <SpecialText style={{ fontWeight: "bold" }}>
              {t("canGenerate")}
            </SpecialText>{" "}
            {` ${t("inlcuding")}`}
          </Typography>
          <Typography
            align="center"
            sx={{
              width: { xs: 9 / 10, md: 3 / 5 },
              fontSize: { xs: 30, md: 40 },
              lineHeight: 1,
              py: 1,
              mt: 15,
              fontWeight: 500,
            }}
          >
            <SpecialText
              style={{
                background: CGI_GRADIENT_A_45DEG,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("evaluateOptimize")}
            </SpecialText>
            {` ${t("compassAdvantages")}`}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              mt: 5,
            }}
          >
            <InfoBoxGradient text={t("aiGeneratedText")} imageSrc={AIIcon} />
            <InfoBoxGradient
              text={t("exportReportToPDF")}
              imageSrc={CloudIcon}
            />
            <InfoBoxGradient
              text={t("enormousTimeSaver")}
              imageSrc={TimesaverIcon}
            />
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
          >
            <InfoBoxGradient
              text={t("automatedBenchmarking")}
              imageSrc={BenchmarkingIcon}
            />
            <InfoBoxGradient
              text={t("fullyCustomizable")}
              imageSrc={CustomizationIcon}
            />
            <InfoBoxGradient
              text={t("unlockNewBusinessOpportunities")}
              imageSrc={BusinessIcon}
            />
          </Box>
          <Typography
            align="center"
            sx={{
              width: { xs: 3 / 5, md: 2 / 5 },
              fontSize: 15.5,
              lineHeight: 1,
              py: 1,
              mt: 5,
              fontFamily: "Inter",
            }}
          >
            {t("compassCentral")}
            efficiently.
          </Typography>
          <Typography
            align="center"
            sx={{
              width: { xs: 3 / 5, md: 2 / 5 },
              fontSize: 15.5,
              lineHeight: 1,
              py: 1,
              fontFamily: "Inter",
            }}
          >
            {t("cgiCompassOffers")}
          </Typography>
          <Typography
            align="center"
            sx={{
              width: { xs: 3 / 5, md: 9 / 20 },
              fontSize: 45,
              lineHeight: 1,
              py: 1,
              mt: 11,
              fontWeight: 500,
            }}
          >
            <SpecialText
              style={{
                background: CGI_GRADIENT_B_45DEG,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("automated")}
            </SpecialText>
            {` ${t("forAll")}`}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", mt: 5 }}>
            <CategoryHexagon category={t("security")} />
            <CategoryHexagon category={t("ai")} />
            <CategoryHexagon category={t("testAutomation")} />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              mt: { xs: -1.5, md: -3.5 },
            }}
          >
            <CategoryHexagon category={t("cloud")} />
            <CategoryHexagon category={t("esg")} />
          </Box>
          <Box
            sx={{
              background: `url(${HexagonDots})`,
              width: { xs: 50, md: 125 },
              height: { xs: 50, md: 125 },
              backgroundSize: "contain",
              mt: { xs: -1.5, md: -3.5 },
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              mt: 10,
            }}
          >
            <Box
              component="img"
              draggable={false}
              src={CompassTablet}
              sx={{
                width: { xs: 0.9, md: 0.45 },
                height: "auto",
                mr: { xs: 0, md: 6 },
                userSelect: "none",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                mx: { xs: 2, md: 0 },
              }}
            >
              <Typography
                align="left"
                sx={{
                  fontSize: { xs: 23, md: 45 },
                  lineHeight: 1,
                  py: 1,
                  mb: 4,
                  fontWeight: 500,
                }}
              >
                <SpecialText
                  style={{
                    background: CGI_GRADIENT_A,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  {t("allTheFeatures")}
                </SpecialText>
                {` ${t("alwaysWanted")}`}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <FeatureBlock
                  heading={t("webBasedTool")}
                  text={t("efficientImplementation")}
                />
                <FeatureBlock
                  heading={t("easySetup")}
                  text={t("forAssessmentFulfillment")}
                  second
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <FeatureBlock
                  heading={t("aiTextAutomation")}
                  text={t("allStatisticsAndTexts")}
                />
                <FeatureBlock
                  heading={t("instantBenchmarking")}
                  text={t("theResultsOfYourAssesment")}
                  second
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <FeatureBlock
                  heading={t("fullyCustomizable")}
                  text={t("theGeneratedRecommendations")}
                />
                <FeatureBlock
                  heading={t("indutryAgnostic")}
                  text={t("cgiCompassOffers")}
                  second
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              mt: 20,
              width: 0.75,
            }}
          >
            <AboutCGI />
            <Box
              component="img"
              draggable={false}
              src={CgiCompassSquare}
              sx={{
                maxWidth: { xs: 0.9, md: 0.45 },
                width: "auto",
                height: "auto",
                objectFit: "contain",
                userSelect: "none",
              }}
            />
          </Box>
        </Box>
        <Typography
          align="left"
          sx={{
            mt: 20,
            fontSize: { xs: 28, md: 50 },
            lineHeight: 1,
            py: 1,
            whiteSpace: "pre-wrap",
            mb: { xs: 1, md: 8 },
            width: { xs: 4 / 5, md: 1 / 2 },
            mx: 4,
            fontWeight: 500,
          }}
        >
          {`${t("moreInformation")} `}
          <SpecialText
            style={{
              background: CGI_GRADIENT_A_45DEG,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t("getInTouch")}
          </SpecialText>
        </Typography>
      </Container>
      <Box
        sx={{
          display: { xs: "flex", md: "none", alignItems: "center" },
          flexDirection: "column",
        }}
      >
        <ContactBoxGradient
          image={ContactTorsten}
          name={"Torsten Täschner"}
          title={"Director Consulting Services"}
          mail={"torsten.taeschner@cgi.com"}
        />
        <Box sx={{ height: 20 }} />
        <ContactBoxGradient
          image={ContactPatrick}
          name={"Patrick Aschkan Jafari"}
          title={"Lead Consultant"}
          mail={"patrickaschkan.jafari@cgi.com"}
        />
        <Box sx={{ height: 20 }} />
        <ContactBoxGradient
          image={ContactJulian}
          name={"Julian Tinapp"}
          title={"Consultant"}
          mail={"julian.tinapp@cgi.com"}
        />
        <Box sx={{ height: 20 }} />
      </Box>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          background: CGI_GREY,
          width: 1,
          height: 210,
          mb: -10,
          mt: 15,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            px: "0 !important",
            mt: -11,
          }}
        >
          <ContactBoxGradient
            image={ContactTorsten}
            name={"Torsten Täschner"}
            title={"Director Consulting Services"}
            mail={"torsten.taeschner@cgi.com"}
          />
          <ContactBoxGradient
            image={ContactPatrick}
            name={"Patrick Aschkan Jafari"}
            title={"Lead Consultant"}
            mail={"patrickaschkan.jafari@cgi.com"}
          />
          <ContactBoxGradient
            image={ContactJulian}
            name={"Julian Tinapp"}
            title={"Consultant"}
            mail={"julian.tinapp@cgi.com"}
          />
        </Container>
      </Box>
    </>
  );
}
